import axios from 'axios';

const getBaseURL = () => {
  return 'https://api.cobra-education.com/api';
  // return 'http://localhost:5000/api';
};

// Create an Axios instance with a base URL
const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0',
  },
});

// Add a request interceptor to include token if available
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add cache buster to GET requests
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: new Date().getTime()
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem('userToken');
      }
      // Use the specific error message from backend if available
      if (error.response.data && error.response.data.error) {
        error.message = error.response.data.error;
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
